import { useEffect, useState } from 'react'
import { Route, Switch, useLocation } from 'wouter'
import { AnimatePresence } from 'motion/react'
import { TabBar } from '@/components/TabBar'
import { Onboarding, hasOnboarded } from '@/components/Onboarding'
import { Home } from '@/routes/Home'
import { Devices } from '@/routes/Devices'
import { Plans } from '@/routes/Plans'
import { Profile } from '@/routes/Profile'
import { Payments } from '@/routes/Payments'
import { Referrals } from '@/routes/Referrals'
import { Partner } from '@/routes/Partner'
import { Settings } from '@/routes/Settings'
import { Faq } from '@/routes/Faq'
import { Support } from '@/routes/Support'
import { initTelegram } from '@/lib/tg'

const SUBPAGE_PREFIX = '/profile/'

export default function App() {
  const [location] = useLocation()
  const [showOnboarding, setShowOnboarding] = useState(() => !hasOnboarded())

  useEffect(() => {
    initTelegram()
  }, [])

  // Hide tab bar on nested / focused pages
  const isSubpage = location.startsWith(SUBPAGE_PREFIX)

  return (
    <div className="flex flex-col h-dvh bg-[var(--color-bg)] text-[var(--color-ink)]">
      <main className="flex-1 flex flex-col overflow-hidden min-h-0">
        <AnimatePresence mode="wait" initial={false}>
          <Switch key={location} location={location}>
            <Route path="/" component={Home} />
            <Route path="/devices" component={Devices} />
            <Route path="/plans" component={Plans} />
            <Route path="/profile" component={Profile} />
            <Route path="/profile/payments" component={Payments} />
            <Route path="/profile/referrals" component={Referrals} />
            <Route path="/profile/partner" component={Partner} />
            <Route path="/profile/settings" component={Settings} />
            <Route path="/profile/faq" component={Faq} />
            <Route path="/profile/support" component={Support} />
            <Route>
              <Home />
            </Route>
          </Switch>
        </AnimatePresence>
      </main>
      {!isSubpage && <TabBar />}
      {showOnboarding && <Onboarding onDone={() => setShowOnboarding(false)} />}
    </div>
  )
}
